import React from "react";

import "./styles.scss";

const Index = ({ title }) => {
  return <span className="title_Sing_ing">{title}</span>;
};
export default Index;
